module.exports = "<div class=\"ubg-right-column ubg-layout-column\">\n  <ng-content></ng-content>\n</div>"